"use client"

import type * as React from "react"
import * as Icons from "lucide-react"

import { NavMain } from "./nav-main"
import { NavSecondary } from "./nav-secondary"
import { NavUser } from "./nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  useSidebar,
} from "@/components/ui/sidebar"
import { ROUTES_CONFIG } from "@/config/routes.config"
import { useAuth } from "@/hooks/use-auth"
import { hasRight } from "@/config/rights.config"



export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user } = useAuth()
  const { open } = useSidebar()

  const data = {
    user: {
      name: `${user?.first_name} ${user?.last_name}`,
      email: user?.email,
      avatar: "",
    },
    navMain: [
      {
        title: "Home",
        url: "#",
        icon: Icons.Home,
        isActive: true,
          items:[
            { title: "Dashboard",
              url: ROUTES_CONFIG.APP.DASHBOARD.$buildPath({}),
              isActive: true
            }
          ]
      },
      {
        title: "Spelers en clubs",
        url: "#",
        icon: Icons.ShieldUser,
        isActive: hasRight(user?.role?.name, "PLAYERS_DB.READ") ||
                  hasRight(user?.role?.name, "CLUB_DB.READ") ||
                  hasRight(user?.role?.name, "SHORTLIST.READ") ||
                  hasRight(user?.role?.name, "LONGLIST.READ"),
          items:[
            {
              title: "Spelers databank",
              url: ROUTES_CONFIG.APP.PLAYER_DB.$buildPath({}),
              isActive: hasRight(user?.role?.name, "PLAYERS_DB.READ")
            },
                        {
              title: "Shortlist",
              url: ROUTES_CONFIG.APP.SHORTLIST.$buildPath({}),
              isActive: hasRight(user?.role?.name, "SHORTLIST.READ")
            },
            {
              title: "Longlist",
              url: ROUTES_CONFIG.APP.LONGLIST.$buildPath({}),
              isActive: hasRight(user?.role?.name, "LONGLIST.READ")
            },
            {
              title: "Club databank",
              url: ROUTES_CONFIG.APP.CLUB_DB.$buildPath({}),
              isActive: hasRight(user?.role?.name, "CLUB_DB.READ")
            }
          ]
      },
      {
        title: "Taken en opdrachten",
        url: "#",
        icon: Icons.ListTodo,
        isActive: hasRight(user?.role?.name, "TASKS.READ"),
        items:[
          {
            title: "Taken",
            url: ROUTES_CONFIG.APP.TASKS.$buildPath({}),
            isActive: hasRight(user?.role?.name, "TASKS.READ")
          }
        ]
      },
      {
        title: "Matchcenter",
        icon: Icons.Trophy,
        url: "#",
        isActive: hasRight(user?.role?.name, "MATCHES.READ"),
          items:[
            {
              title: "Wedstrijden",
              url: ROUTES_CONFIG.APP.MATCHES.$buildPath({}),
              isActive: hasRight(user?.role?.name, "MATCHES.READ")
            }
          ]
      },  
      {
        title: "Contacten",
        icon: Icons.Contact,
        url: "#",
        isActive: hasRight(user?.role?.name, "CONTACTS.READ"),
          items:[
            {
              title: "Contacten",
              url: ROUTES_CONFIG.APP.CONTACTS.$buildPath({}),
              isActive: hasRight(user?.role?.name, "CONTACTS.READ")
            }
          ]
      },
      {
        title: "Instellingen",
        icon: Icons.Settings,
        url: "#",
        isActive: hasRight(user?.role?.name, "SETTINGS.READ"),
          items:[
            {
              title: "Rapportinstellingen",
              url: ROUTES_CONFIG.APP.REPORTS.$buildPath({}),
              isActive: hasRight(user?.role?.name, "REPORTS.READ")
            }
          ]
      },
      {
        title: "Gebruikersbeheer",
        icon: Icons.UsersRound,
        url: ROUTES_CONFIG.APP.USER_MANAGEMENT.$buildPath({}),
        isActive: hasRight(user?.role?.name, "USER_MANAGEMENT.READ")
      },
      // {
      //   title: "Notificaties",
      //   icon: Icons.Bell,
      //   url: "#",
      //   isActive: true
      // }
    ],
    navSecondary: [
      // {
      //   title: "Support",
      //   url: "#",
      //   icon: Icons.LifeBuoy,
      // },
      // {
      //   title: "Feedback",
      //   url: "#",
      //   icon: Icons.Send,
      // },
    ]
  }

  return (
    <Sidebar variant="inset" collapsible="icon" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem className="flex items-center justify-between">
            {open && 
            <SidebarMenuButton size="lg" asChild>
              <a href="#">
                <div className="flex aspect-square size-8 items-center justify-center rounded-lg">
                  <img src="/img/logo/emblem.svg" alt="Logo" className="h-full w-full" />
                </div>
                <img src="/img/logo/letters-left.svg" alt="Logo" className="h-8" />
              </a>
            </SidebarMenuButton>
            }
            <SidebarTrigger className="w-8 h-8"/>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain?.filter(i => i.isActive)} />
        {/* <NavProjects projects={data.projects} /> */}
        <NavSecondary items={data.navSecondary} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={data.user} />
      </SidebarFooter>
    </Sidebar>
  )
}
